import { format, parseISO, isValid } from "date-fns";

export function fmtDate(d) {
  if (!d) return "—";
  try {
    const dt = typeof d === "string" ? parseISO(d) : d;
    return isValid(dt) ? format(dt, "dd MMM yyyy") : "—";
  } catch { return "—"; }
}

export function fmtDateTime(d, t) {
  const base = fmtDate(d);
  return t ? `${base} · ${t}` : base;
}

export function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}

export const CASE_STATUSES = [
  { value: "active", label: "Active" },
  { value: "pending", label: "Pending" },
  { value: "closed", label: "Closed" },
  { value: "disposed", label: "Disposed" },
];

export const CASE_TYPES = [
  "Civil Suit", "Criminal", "Property Dispute", "Family / Matrimonial",
  "Consumer", "Cheque Bounce (138 NI Act)", "Writ Petition", "Company / Commercial", "Other",
];

export const HEARING_STATUSES = ["scheduled", "completed", "adjourned", "cancelled"];
export const TASK_STATUSES = [
  { value: "todo", label: "To Do" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
];
export const PRIORITIES = ["low", "medium", "high", "urgent"];

export function statusColor(status) {
  const map = {
    active: "bg-emerald-50 text-emerald-700 border-emerald-200",
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    closed: "bg-slate-100 text-slate-600 border-slate-200",
    disposed: "bg-blue-50 text-blue-700 border-blue-200",
    scheduled: "bg-blue-50 text-blue-700 border-blue-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
    adjourned: "bg-amber-50 text-amber-700 border-amber-200",
    cancelled: "bg-rose-50 text-rose-700 border-rose-200",
    todo: "bg-slate-100 text-slate-600 border-slate-200",
    in_progress: "bg-blue-50 text-blue-700 border-blue-200",
  };
  return map[status] || "bg-slate-100 text-slate-600 border-slate-200";
}

export function priorityColor(p) {
  const map = {
    low: "bg-slate-100 text-slate-600 border-slate-200",
    medium: "bg-blue-50 text-blue-700 border-blue-200",
    high: "bg-amber-50 text-amber-700 border-amber-200",
    urgent: "bg-rose-50 text-rose-700 border-rose-200",
  };
  return map[p] || map.low;
}
